import { BackgroundColors } from '@picsart/design-system/foundation/colors';

import { Spacings } from '@picsart/design-system/foundation/spacings';
import { mediaQuery } from '@picsart/rc/helpers';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  () => ({
    root: {
      background: BackgroundColors.base,
      position: 'relative',
      height: 768,
      padding: [Spacings.s72, Spacings.s0],

      [mediaQuery(1023)]: {
        height: 520,
      },
    },
    title: {
      textAlign: 'center',
      paddingBottom: 20,
    },
    skeletonTitle: {
      extend: 'title',
      maxWidth: '35%',
      height: 40,
      margin: '0px auto 40px ',
      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        maxWidth: '75%',
        height: 60,
      },
    },
  }),
  {
    name: 'home-page-banner-desktop',
  },
);

export default useStyles;
